import React from 'react';
import { Box, Container } from '@mui/material';
import WelcomeHero from './WelcomeHero';
import LoginCompactTable from './LoginCompactTable';

function Login() {

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          marginTop: { xs: 1, sm: 4 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <WelcomeHero />
        
        {/* Market Overview Section */}
        <Box sx={{ width: '100%', mt: 4 }}>
          <LoginCompactTable />
        </Box>
      </Box>
    </Container>
  );
}

export default Login; 